import { render } from "./reclaim-bucket.vue?vue&type=template&id=1e5bf8ce"
import script from "./reclaim-bucket.vue?vue&type=script&lang=js"
export * from "./reclaim-bucket.vue?vue&type=script&lang=js"

import "./reclaim-bucket.vue?vue&type=style&index=0&id=1e5bf8ce&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__